import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { GoogleMapModule } from '@lib/geo/google/map';
import { SnVideoPlayerModule } from '@lib/player/video-player';
import { TranslationModule, TranslationService } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { VehicleIntelligenceModule } from '@lib/vehicle-intelligence';

import {
  AlarmCardComponent,
  AlarmDetailsPopupComponent,
  AlarmSendDialogComponent,
  AlertBoundaryControlsComponent,
  SnAmberAlertDetailsComponent,
} from './components';
import { AlarmsService } from './services/alarms.service';
import { AlarmsWidgetComponent } from './widgets/alarms/alarms-widget.component';

@NgModule({
  imports: [
    CommonModule,
    SnCommonModule,
    MatCardModule,
    MatMenuModule,
    MatDialogModule,
    MatListModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSortModule,
    SnIconModule,
    SnButtonModule,
    SnFormModule,
    GoogleMapModule,
    SnVideoPlayerModule,
    ClipboardModule,
    MatTooltipModule,
    MatRippleModule,
    TranslationModule,
    VehicleIntelligenceModule,
  ],
  exports: [
    AlarmCardComponent,
    SnAmberAlertDetailsComponent,
    AlarmsWidgetComponent,
    AlertBoundaryControlsComponent,
    AlarmDetailsPopupComponent,
  ],
  declarations: [
    AlarmCardComponent,
    AlarmsWidgetComponent,
    AlarmSendDialogComponent,
    SnAmberAlertDetailsComponent,
    AlertBoundaryControlsComponent,
    AlarmDetailsPopupComponent,
  ],
  providers: [
    AlarmsService,
    {
      provide: MatPaginatorIntl,
      useFactory: (translationService: TranslationService) => translationService.createTranslatedPaginatorIntl(),
      deps: [TranslationService],
    },
  ],
})
export class AlarmsModule {}
